import { useContext, useState } from 'react';
import { ThemeContext } from '~/lib/ThemeContext';
import { formatCurrency } from '~/lib/CurrencyHelpers';
import { formatDateShort } from '~/lib/DateTime';
import { PrimaryColor } from '~/lib/Styles';
import Toggle from '~/components/Toggle.jsx';
import OptionToggle from '~/components/OptionToggle.jsx';

const PrintableGiftCertificate = ({
    className,
    small,
    print,
    business,
    recipient,
    message,
    image,
    value,
    remainingValue,
    expires,
    code,
}) => {
    const { color } = useContext(ThemeContext);
    const [printGreyscaleToggle, setPrintGreyscaleToggle] = useState(false);

    const greyscale = printGreyscaleToggle && print;

    const backgroundUrl =
        image && !greyscale ? `${image}&w=${small ? '400' : '900'}` : '';

    const dropShadow = greyscale ? '' : 'drop-shadow';

    return (
        <div>
            {!!print && (
                <label className="text-center mb-4 flex items-center text-gray-500 print:hidden">
                    <Toggle
                        enabled={printGreyscaleToggle}
                        setEnabled={setPrintGreyscaleToggle}
                        className="mr-2"
                    />
                    Print black and white
                </label>
            )}
            <div
                className={`rounded-xl ${small ? 'min-h-[200px] text-base p-6' : 'text-xl min-h-[400px] p-10 '} flex flex-col justify-between ${greyscale ? 'text-black border border-gray-400 border-2 border-dashed' : 'text-white'} ${className}`}
                style={{
                    backgroundColor: greyscale
                        ? '#FFFFFF'
                        : color || PrimaryColor,
                    backgroundImage: `url(${backgroundUrl})`,
                }}
            >
                <div className="flex items-start justify-between">
                    <div className={dropShadow}>
                        <div className="font-bold">To:</div>
                        <div className="font-semibold">{recipient.name}</div>
                    </div>
                    <div
                        className={`${dropShadow} ${small ? 'text-[40px]' : 'text-[80px]'}`}
                    >
                        {formatCurrency(value)}
                        {value != remainingValue &&
                            typeof remainingValue !== 'undefined' && (
                                <div className="text-lg text-right mt-8">
                                    {formatCurrency(remainingValue)} remaining
                                </div>
                            )}
                    </div>
                </div>

                {!!message && (
                    <div className={`${dropShadow} font-semibold`}>
                        {message}
                    </div>
                )}

                <div className="flex items-start justify-between">
                    <div className={`${dropShadow} font-semibold`}>
                        {business?.name}
                    </div>
                    <div
                        className={`${dropShadow} ${small ? 'text-base' : 'text-lg'} font-semibold`}
                    >
                        <div>Code: {code}</div>
                        <div>
                            Expires:{' '}
                            {expires ? formatDateShort(expires) : 'Never'}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrintableGiftCertificate;
